<template>
  <v-text-field
    class="textfield"
    outlined
    v-bind="$attrs"
    v-on="$listeners"
    dense
  ></v-text-field>
</template>

<style>
.textfield fieldset {
  border-radius: 0;
}
.textfield .v-input__prepend-outer {
  background-color: #fb8c00 !important;
  height: 40px;
  width: 40px;
  position: relative;
  top: -8px;
  padding-top: 8px;
  border-radius: 5px !important;
  margin-left: 0px;
}
.textfield .v-input__control > .v-input__slot fieldset{
  border-radius: 5px !important
}
.textfield .v-input__prepend-outer i {
  color: #ffffff !important;
}
</style>
<script>
export default {
}
</script>
